export default function rendercrewte(movieDataExists, fieldname) {
  if (movieDataExists.Crew) {
    const arraydata = movieDataExists.Crew.map(e => {
      if (e.movieRole_En === fieldname) {
        return {
          PK: e.PK,
          SK: e.SK,
          role: e.movieRole_En,
          name_En: e.name_En,
          name_Te: e.name_Te,
          personID: e.personID,
          personUUID: e.personUUID,
          weight: e.weight,
          position: e.position,
          isAnonymous: e.isAnonymous,
          posterURL: e.posterURL,
          GSIPersonStatusAndPersonID: e.GSIPersonStatusAndPersonID,
        }
      }

      return undefined
    })
    const arraycrew = arraydata.filter(element => element !== undefined && element !== null)
    return arraycrew
      .sort((a, b) => parseFloat(a.position) - parseFloat(b.position))
      .map(e => (e.name_Te ? e.name_Te : ''))
  }

  return []
}
